import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  KeyboardView,
  Wrapper,
  Card,
  CardBody
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";

import GenerateText from "./GenerateText";
import Media from "./Media";

import {
  appRedirect,
  toggleOnboarding,
  setFeatureModal,
  loadPlanOnboardingInfo,
  setPricingPage,
  togglePricingPage
} from "app/NativeActions";

import OnboardingLandingPage from "./OnboardingLandingPage";

class OnboardingContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_info: null,
      loading: true
    };
  }

  componentDidMount() {
    loadPlanOnboardingInfo(
      this.props.contentful_slug ? this.props.contentful_slug : this.props.slug
    )
      .then(data => {
        if (data && data.items) {
          if (data.items.length > 0) {
            this.setState({
              onboarding_info: data.items[0]
                ? data.items[0].fields
                  ? data.items[0].fields
                  : null
                : null,
              loading: false
            });
          }
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  componentDidUpdate(prevProps) {}

  renderHeader() {
    if (!this.props.noHeader) {
      return (
        <Header
          title={this.state.onboarding_info.containerTitle}
          leftButtonIcon={this.props.leftButtonIcon}
          leftButtonAction={this.props.leftButtonAction}
          rightButtonTitle={this.props.rightButtonTitle}
          rightButtonAction={this.props.rightButtonAction}
        />
      );
    }
  }

  render() {
    if (this.state.loading == false && this.state.onboarding_info != null) {
      if (this.props.isCard) {
        return (
          <Card>
            <CardBody>
              <Media
                {...this.props}
                onboarding_info={this.state.onboarding_info}
              />
              <GenerateText
                {...this.props}
                center={this.props.isMobile ? true : false}
                onboarding_info={this.state.onboarding_info}
                onboarding_title={this.state.onboarding_info.onboardingTitle}
                onboarding_text={this.state.onboarding_info.onboardingText}
                primaryButtonText={
                  this.state.onboarding_info.onboardingButtonText
                }
                secondaryButtonText={
                  this.state.onboarding_info.learnMoreButtonText
                }
                secondaryButtonLink={
                  this.state.onboarding_info.learnMoreButtonLink
                }
              />
            </CardBody>
          </Card>
        );
      }

      if (this.props.noContainer) {
        return (
          <Wrapper style={{ flex: 1, ...this.props.style }}>
            {this.renderHeader()}
            <KeyboardView>
              <Wrapper
                style={{
                  padding: 20,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Media
                  {...this.props}
                  onboarding_info={this.state.onboarding_info}
                />

                <GenerateText
                  {...this.props}
                  center={this.props.isMobile ? true : false}
                  onboarding_info={this.state.onboarding_info}
                  onboarding_title={this.state.onboarding_info.onboardingTitle}
                  onboarding_text={this.state.onboarding_info.onboardingText}
                  primaryButtonText={
                    this.state.onboarding_info.onboardingButtonText
                  }
                  secondaryButtonText={
                    this.state.onboarding_info.learnMoreButtonText
                  }
                  secondaryButtonLink={
                    this.state.onboarding_info.learnMoreButtonLink
                  }
                />
              </Wrapper>
            </KeyboardView>
          </Wrapper>
        );
      }

      if (this.state.onboarding_info.landingPage) {
        return (
          <Container
            style={{ flex: 1 }}
            includeInfoBanner={this.props.includeInfoBanner}
          >
            {this.renderHeader()}
            <KeyboardView style={{ maxWidth: 1200 }}>
              <OnboardingLandingPage
                {...this.props}
                center={this.props.isMobile ? true : false}
                onboarding_info={this.state.onboarding_info}
                onboarding_title={this.state.onboarding_info.onboardingTitle}
                onboarding_text={this.state.onboarding_info.onboardingText}
                primaryButtonText={
                  this.state.onboarding_info.onboardingButtonText
                }
                secondaryButtonText={
                  this.state.onboarding_info.learnMoreButtonText
                }
                secondaryButtonLink={
                  this.state.onboarding_info.learnMoreButtonLink
                }
              />
            </KeyboardView>
          </Container>
        );
      }

      return (
        <Container style={{ flex: 1 }}>
          {this.renderHeader()}
          <KeyboardView style={{ maxWidth: 1200 }}>
            <Wrapper
              style={{
                padding: 20,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Media
                {...this.props}
                onboarding_info={this.state.onboarding_info}
              />
              <GenerateText
                {...this.props}
                center={this.props.isMobile ? true : false}
                onboarding_info={this.state.onboarding_info}
                onboarding_title={this.state.onboarding_info.onboardingTitle}
                onboarding_text={this.state.onboarding_info.onboardingText}
                primaryButtonText={
                  this.state.onboarding_info.onboardingButtonText
                }
                secondaryButtonText={
                  this.state.onboarding_info.learnMoreButtonText
                }
                secondaryButtonLink={
                  this.state.onboarding_info.learnMoreButtonLink
                }
              />
            </Wrapper>
          </KeyboardView>
        </Container>
      );
    }

    return <Container style={{ flex: 1 }} />;
  }
}

const mapStateToProps = ({ auth, native, billing }) => {
  const { token, user } = auth;
  const { device, platform, isMobile } = native;
  const { card_info } = billing;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    card_info
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  setFeatureModal,
  toggleOnboarding,
  setPricingPage,
  togglePricingPage
})(OnboardingContainer);
